const circles = document.querySelectorAll('.circle');
    let rotations = Array(circles.length).fill(0); // Array to track rotation for each circle

    window.addEventListener('scroll', () => {
      const scrollDirection = Math.sign(window.scrollY - (this.lastScrollY || 0));
      
      circles.forEach((circle, index) => {
        rotations[index] += scrollDirection * 2; // Adjust rotation speed (5 degrees per scroll step)
        circle.style.transform = `rotate(${rotations[index]}deg)`;
      });

      this.lastScrollY = window.scrollY;
    });